<dx-popup
    width="52%"
    height="86%"
    [minHeight]="500"
    [minWidth]="450"
    [title]="titleText"
    [showTitle]="true"
    [dragEnabled]="true"
    [deferRendering]="true"
    [showCloseButton]="true"
    [resizeEnabled]="true"
    [visible]="visible"
    (onShown)="onShown($event)"
    (onHiding)="onHidden()"
    (onResizeEnd)="onResizeEnd()"
>
    <div
        *dxTemplate="let model of 'content'"
        id="portal-announcement-editor-content"
        class="portal-announcement-editor-content"
    >
        <dx-form
            *ngIf="!!editorResult"
            #editorForm
            width="100%"
            height="100%"
            labelLocation="left"
            [colCount]="1"
            [scrollingEnabled]="true"
        >
            <dxi-item [isRequired]="true" [visible]="!showEmailInFullScreen">
                <dxo-label text="Context"></dxo-label>
                <div *dxTemplate>
                    <app-user-context-tree
                        selectionMode="multiple"
                        contextTypeSelectionMode="single"
                        [showGlobalNode]="editorResult.allowGlobalAnnouncements"
                        [allowGlobalSelection]="editorResult.allowGlobalAnnouncements"
                        [allowManagementCompanySelection]="editorResult.allowManagementCompanyAnnouncements"
                        [allowLocationSelection]="editorResult.allowLocationAnnouncements"
                        [contextTreeBoxValue]="editorData.contextList"
                        (contextTreeBoxValueChange)="onContextSelection($event)"
                    ></app-user-context-tree>
                </div>
            </dxi-item>
            <dxi-item [isRequired]="true" [visible]="!showEmailInFullScreen">
                <dxo-label text="Audience"></dxo-label>
                <div *dxTemplate class="editor-inline-content">
                    <dx-tag-box
                        #multiSelector
                        displayExpr="displayText"
                        valueExpr="key"
                        [multiline]="false"
                        [showSelectionControls]="true"
                        [dataSource]="editorResult.audiences"
                        [(value)]="editorData.audienceCodes"
                    ></dx-tag-box>
                </div>
            </dxi-item>
            <dxi-item [isRequired]="true" [visible]="!showEmailInFullScreen">
                <dxo-label text="Heading"></dxo-label>
                <div *dxTemplate>
                    <dx-text-box [(value)]="editorData.title"></dx-text-box>
                </div>
            </dxi-item>
            <dxi-item itemType="group" [colCount]="2" [visible]="!showEmailInFullScreen">
                <dxi-item [isRequired]="true">
                    <dxo-label text="Release On"></dxo-label>
                    <div *dxTemplate class="editor-inline-content">
                        <dx-date-box type="date" [min]="todayDate" [(value)]="editorData.releaseDate"></dx-date-box>
                        <i>(Releases at beginning of selected date)</i>
                    </div>
                </dxi-item>
                <dxi-item [isRequired]="true">
                    <dxo-label text="Expires On"></dxo-label>
                    <div *dxTemplate class="editor-inline-content">
                        <dx-date-box
                            type="date"
                            [min]="editorData.releaseDate || todayDate"
                            [(value)]="editorData.expirationDate"
                        ></dx-date-box>
                        <i>(Expires at end of selected date)</i>
                    </div>
                </dxi-item>
            </dxi-item>
            <dxi-item [isRequired]="true">
                <dxo-label *ngIf="!showEmailInFullScreen" text="Content"></dxo-label>
                <div *dxTemplate>
                    <editor #htmlEditor [init]="editorOptions" [(ngModel)]="editorData.content"></editor>
                    <input id="imageInput" type="file" hidden="true" accept="image/*" />
                </div>
            </dxi-item>
            <dxi-item itemType="empty" [visible]="!showEmailInFullScreen"></dxi-item>
            <dxi-item itemType="group" [colCount]="2" [visible]="!showEmailInFullScreen">
                <dxi-item
                    itemType="button"
                    horizontalAlignment="left"
                    verticalAlignment="bottom"
                    [buttonOptions]="{
                        type: 'default',
                        text: 'Close',
                        hint: 'Close',
                        icon: iconClose,
                        onClick: onCloseClick
                    }"
                ></dxi-item>
                <dxi-item
                    itemType="button"
                    horizontalAlignment="right"
                    verticalAlignment="bottom"
                    [buttonOptions]="{
                        type: 'success',
                        text: 'Save',
                        hint: 'Save',
                        icon: iconSave,
                        onClick: onSaveClick
                    }"
                ></dxi-item>
            </dxi-item>
        </dx-form>
    </div>
</dx-popup>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#portal-announcement-editor-content' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
